import { type ComponentLayout } from './types'

export const AnaplanConfig: ComponentLayout = {
  componentId: 'modular-anaplan-input-v1',
  wizard: {
    steps: [
      {
        stepId: 'connect',
        displayName: 'Connect',
        previousStepId: null,
        nextStepId: 'configure',
        parameters: [
          {
            dplId: 'connection'
          }
        ]
      },
      {
        stepId: 'configure',
        displayName: 'Configure',
        previousStepId: 'connect',
        nextStepId: 'destination',
        parameters: [
          {
            dplId: 'anaplan-input-v1',
            omitParameters: ['connection']
          }
        ]
      },
      {
        stepId: 'destination',
        displayName: 'Destination',
        previousStepId: 'configure',
        nextStepId: null,
        parameters: [
          {
            dplId: 'outputId'
          },
          {
            dplId: 'snowflake-output-connector-v0'
          },
          {
            dplId: 'storage-only-output-v0'
          },
          {
            dplId: 'redshift-output-connector-v0'
          }
        ]
      }
    ]
  }
}
